module.exports = __webpack_public_path__ + "img/monsterleads.213a2b90.png";